<section class="section white-100 verto-dials-display">
  <div [ngClass]="isInside ? 'section-container-inside' : 'section-container'">
    <h2 class="section-heading mar-b-48">
      {{ _differenceData?.title }}
    </h2>
    <div class="verto-dials">
      <div class="verto-dials-header">
        <div class="row-padd-24-c">&nbsp;</div>
        <div class="coloumn-middle row-padd-24-c">
          {{ _differenceData?.pricingTable?.[0]?.fields?.text1 }}
        </div>
        <div class="verto-dials-coloumn-middle row-padd-24-c">
          {{ _differenceData?.pricingTable?.[0]?.fields?.text2 }}
        </div>
        <div class="row-padd-24-c">
          {{ _differenceData?.pricingTable?.[0]?.fields?.text3 }}
        </div>
      </div>
      <ng-container
        *ngFor="let row of _differenceData?.pricingTable; let i = index"
      >
        <div class="verto-dials-row" *ngIf="i !== 0">
          <div
            class="row-padd-24-l verto-dials-coloumn-middle verto-dials-content"
          >
            {{ row?.fields?.title }}
          </div>
          <div
            class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content"
          >
            <ng-container *ngIf="row?.fields?.text1">
              {{ row?.fields?.text1 }}
            </ng-container>
            <ng-container *ngIf="row?.fields?.psRowImage">
              <img
                src="{{ row?.fields?.psRowImage?.fields.file?.url }}"
                alt="{{ row?.fields?.psRowImage?.fields?.title }}"
              />
            </ng-container>
          </div>
          <div
            class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content"
          >
            <ng-container *ngIf="row?.fields?.text1">
              {{ row?.fields?.text2 }}
            </ng-container>
            <ng-container *ngIf="row?.fields?.psRowImage2">
              <img
                src="{{ row?.fields?.psRowImage2?.fields.file?.url }}"
                alt="{{ row?.fields?.psRowImage2?.fields?.title }}"
              />
            </ng-container>
          </div>
          <div class="row-padd-24-c verto-dials-content">
            <ng-container *ngIf="row?.fields?.text1">
              {{ row?.fields?.text3 }}
            </ng-container>
            <ng-container *ngIf="row?.fields?.psRowImage3">
              <img
                src="{{ row?.fields?.psRowImage3?.fields.file?.url }}"
                alt="{{ row?.fields?.psRowImage3?.fields?.title }}"
              />
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- <div class="verto-dials-row">
                <div class="row-padd-24-l verto-dials-coloumn-middle verto-dials-content">
                    Global money movement
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    49+ currencies
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    20 currencies, 1% fee
                </div>
                <div class="row-padd-24-c verto-dials-content">$250K</div>
            </div>
            <div class="verto-dials-row">
                <div class="row-padd-24-l verto-dials-coloumn-middle verto-dials-content">
                    No transaction fees
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    Up to $5M through program banks
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    Up to $5M through program banks
                </div>
                <div class="row-padd-24-c verto-dials-content">Varies</div>
            </div>
            <div class="verto-dials-row">
                <div class="row-padd-24-l verto-dials-coloumn-middle verto-dials-content">
                    Global money movement
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    <img src="resources/img/svg/icons/ico-tick-circle.svg" />
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    <img src="resources/img/svg/icons/ico-close.svg" />
                </div>
                <div class="row-padd-24-c verto-dials-content">
                    <img src="resources/img/svg/icons/ico-close.svg" />
                </div>
            </div>
            <div class="verto-dials-row">
                <div class="row-padd-24-l verto-dials-coloumn-middle verto-dials-content">
                    No transaction fees
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    <img src="resources/img/svg/icons/ico-tick-circle.svg" />
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    <img src="resources/img/svg/icons/ico-close.svg" />
                </div>
                <div class="row-padd-24-c verto-dials-content">
                    <img src="resources/img/svg/icons/ico-close.svg" />
                </div>
            </div>
            <div class="verto-dials-row">
                <div class="row-padd-24-l verto-dials-coloumn-middle verto-dials-content">
                    Global money movement
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    49+ currencies
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    20 currencies, 1% fee
                </div>
                <div class="row-padd-24-c verto-dials-content">$250K</div>
            </div>
            <div class="verto-dials-row">
                <div class="row-padd-24-l verto-dials-coloumn-middle verto-dials-content">
                    Integrated, automated bill pay
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    Included
                </div>
                <div class="row-padd-24-c verto-dials-coloumn-middle verto-dials-content">
                    Limited
                </div>
                <div class="row-padd-24-c verto-dials-content">Limited</div>
            </div> -->
    </div>
  </div>
</section>
